export default __webpack_public_path__ + "static/media/Mulish-Regular.18a0df44.ttf";